<wuc-button (buttonClick)="requestInternationalMotorInsuranceCard()" type="secondary" [isFullWidth]="true"
            iconType="primary" [iconLeft]="loading ? 'insurances' : 'mail'" [disabled]="isDisabled || loading">
    E-mail
</wuc-button>
